
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Title from './pages/Title';
import Opening from './pages/Opening';
import Game from './pages/Game';
import Ending from './pages/Ending';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Title />} />
        <Route path="/opening" element={<Opening />} />
        <Route path="/game" element={<Game />} />
        <Route path="/ending" element={<Ending />} />
      </Routes>
    </Router>
  );
};

export default App;